import { css } from '@emotion/react';

export const formStyles = {
  modalTitle: css({ marginTop: 0 }),
  fullWidthSpace: css({ display: 'flex', width: '100%' }),
  flexOne: css({ flex: 1 }),
  locationContainer: css({
    display: 'flex',
    marginBottom: 16,
    padding: 16,
    border: '1px solid #f0f0f0',
    borderRadius: 8,
  }),
  locationHeader: css({ display: 'flex' }),
  sectionTitle: css({ marginTop: 16 }),
};

/** Origin type codes; labels: `plantings:form.origin.type.<code>`. */
export const ORIGIN_TYPES = [
  'seed', 'cutting', 'seedling', 'division', 'graft', 'layering', 'bulb', 'transplant_in',
] as const;
